var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 14.2598L5.53049 21.7282C5.35883 21.8999 5.15106 21.988 4.90724 21.9926C4.66341 21.9972 4.45108 21.9091 4.27028 21.7282C4.08943 21.5474 3.99902 21.3374 3.99902 21.0981C3.99902 20.8589 4.08943 20.6488 4.27028 20.468L11.7388 12.9995L4.27028 5.53094C4.09857 5.35931 4.01045 5.15155 4.00589 4.90771C4.00131 4.66388 4.08943 4.45154 4.27028 4.27075C4.45108 4.0899 4.66112 3.99951 4.90036 3.99951C5.13963 3.99951 5.34967 4.0899 5.53049 4.27075L12.999 11.7393L20.4675 4.27075C20.6392 4.09906 20.847 4.01093 21.0908 4.00635C21.3346 4.00177 21.547 4.0899 21.7278 4.27075C21.9086 4.45154 21.999 4.66156 21.999 4.90082C21.999 5.14014 21.9086 5.35016 21.7278 5.53094L14.2593 12.9995L21.7278 20.468C21.8995 20.6397 21.9876 20.8474 21.9921 21.0912C21.9967 21.3351 21.9086 21.5474 21.7278 21.7282C21.547 21.9091 21.3369 21.9995 21.0977 21.9995C20.8584 21.9995 20.6484 21.9091 20.4675 21.7282L12.999 14.2598Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.fed2de23ed2b9a4f1648ad523b603f65.svg";
export { ForwardRef as ReactComponent };